import { useQuery } from '@tanstack/react-query';
import { useAccountsService } from '@restworld/data-services';

export const CONSUMPTION_DETAILS_QUERY_KEY = ['consumptionDetails'];

export const useConsumptionDetails = (enabled = true) => {
  const accountsService = useAccountsService();

  return useQuery({
    queryKey: CONSUMPTION_DETAILS_QUERY_KEY,
    queryFn: async () => {
      const response = await accountsService.getConsumptionDetails();
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};
